import { Injectable }           from '@angular/core';
import { Http, Response }       from '@angular/http';
import { Observable }           from 'rxjs/Observable';
import { ConfigService }        from '../configuracion/config.service';
import { RequestBaseService }   from '../request-base/request-base.service';
import { JwtHttp, AuthService } from 'ng2-ui-auth';
import { FileUploader }         from 'ng2-file-upload';

import 'rxjs/add/operator/map';

@Injectable()
export class CategoriasService extends RequestBaseService {
  constructor(
    protected http: JwtHttp,
    protected auth: AuthService,
    config: ConfigService
  ) {
    super(http, auth);
    this.ApiUrl = [config.getApiUrl(), 'categoria'].join('/');
  }

  public save(model: any): Observable<any> {
    let file: FileUploader = model.imagen;

    model.imagen = '';

    delete model['imagen'];

    console.log(model);

    return new Observable(observer => {
      super.save(model)
        .subscribe(
          data => {
            try {
              if (file.queue.length > 0) {
                file.authToken = this.auth.getToken();
                file.options.url = [this.ApiUrl, data.id, 'upload'].join('/');

                file.queue.forEach(queue => {
                  queue.url = [this.ApiUrl, data.id, 'upload'].join('/');

                  queue.upload();

                  if (!!queue._xhr) {
                    queue._xhr.onreadystatechange = function(e) {
                      if (queue._xhr.readyState == 4) {
                        data.image = [data.id, 'jpg'].join('.');

                        observer.next(data);
                      }
                    }                
                  }
                });
              } else {
                observer.next(data);
              }              
            }
            catch (ex) {
              console.error(ex);
            }
          },
          error => console.error(error)
        );      
    });
  }

  public update(id:any, model: any): Observable<any> {
    let file: FileUploader = model.imagen;

    model.imagen = [id, 'jpg'].join('.');

    return new Observable(observer => {
      super.update(id, model)
        .subscribe(
          data => {
            if (file.queue.length > 0) {
              file.authToken = this.auth.getToken();
              file.options.url = [this.ApiUrl, data.id, 'upload'].join('/');
              file.queue[0].url = [this.ApiUrl, data.id, 'upload'].join('/');

              file.queue[0].upload();

              file.queue[0]._xhr.onreadystatechange = function(e) {
                if (file.queue[0]._xhr.readyState == 4) {
                  data.image = [data.id, 'jpg'].join('.');

                  observer.next(data);
                }
              }
            } else {
              observer.next(data);
            }
          },
          error => console.error(error)
        );      
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/categorias/categorias.service.ts